<div class="table-container h-full overflow-auto" [ngClass]="{'auto-fit-content': hasSingleRow, 'prevent-row-stretch': hasMultipleRows}">
  <table
    mat-table
    [dataSource]="_data"
    class="bg-transparent !border !border-solid !border-gray rounded-xl"
    [ngClass]="class"
    >
    @for (column of _config.Columns; track column) {
      <ng-container
        [matColumnDef]="column.columnId"
        >
        <th
          mat-header-cell
          *matHeaderCellDef
          class="rounded-t-xl text-bold"
          [ngClass]="getHeaderCellClass(column)"
          >
          <span>{{ column.header }}</span>
        </th>
        <td
          mat-cell
          *matCellDef="let element; let i = index"
          [ngClass]="getCellClass(element, column)"
          [ngStyle]="getCellStyles(element, column)"
          >
          @switch (column.columnType.type) {
            @case (columnTypes.Text) {
              <span>{{ element[column.columnId] }}</span>
              @if (column.columnType.columnData?.valueSuffix?.(element); as suffix) {
                <span
                  [ngClass]="suffix.cssClass">
                  {{ suffix.text }}
                </span>
              }
            }
            @case (columnTypes.Icon) {
              @if (column.columnType.columnData.hasImage(element)) {
                @if (column.columnType.columnData.getAlt?.(element); as iconAlt) {
                  <img
                    [src]="iconAssetUrl(column.columnType.columnData.getImage(element))"
                    [alt]="iconAlt"
                    class="colored-icon crowdedness-icon"
                    />
                } @else {
                  <ng-icon
                    [name]="column.columnType.columnData.getImage(element)"
                    class="colored-icon"
                    aria-hidden="true"
                    />
                }
              }
            }
          }
        </td>
      </ng-container>
    }

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

    <tr class="mat-row no-data-row" *matNoDataRow>
      <td class="mat-cell align-top" colspan="9999">
        <img
          src="/assets/images/route-planning/table_empty.svg"
          class="w-full"
          [alt]="emptyAlt"
          />
      </td>
    </tr>
  </table>
</div>
